import { useModelService } from 'services/model/model.service';
import { measureKpi, InfoDrawerKpiEntry } from 'components/InfoDrawer/InfoDrawerKpiEntry';
import { InfoDrawerKpis } from 'components/InfoDrawer/InfoDrawerKpis';

function useTopSellingProductsKpis(): InfoDrawerKpiEntry[] {
  const { getMeasures } = useModelService();

  const [netSlsQty, netSlsGmvVal, itemNetSlsGmvVal, retQtyRate] = getMeasures([
    'netSlsQtyExpOD',
    'netSlsGmvValExpOD',
    'itemNetSlsGmvValExpOD',
    'retQtyRateExpOD',
  ]);

  return [measureKpi(netSlsQty), measureKpi(netSlsGmvVal), measureKpi(itemNetSlsGmvVal), measureKpi(retQtyRate)];
}

export function TopSellingProductsInfoContent() {
  const kpis = useTopSellingProductsKpis();

  return (
    <InfoDrawerKpis.Default
      kpis={kpis}
      whyUsefulTitleId="info.content.why_is_it_useful"
      whyUsefulDescriptionId="insights.marketplace_tab.top_selling_products.report.why_is_it_useful"
      showOrderBasedNote
    />
  );
}
